import { SUPABASE_URL, getDbHeaders, cutoffDateISO } from "./client";

// -- Message DB helpers -------------------------------------------------------
export async function dbLoadMessages() {
  // Load all messages within the 7-day retention window — NOT filtered by appDate
  // (appDate is for connection cards only; messages are a separate comms thread)
  // Airline-level filtering is enforced by RLS (messages_select policy).
  const cols = "id,date,from_airline,to_airline,body,urgent,read,read_at,created_at,connection_id,from_scco_name,attachment_url,attachment_name,msg_type,amenity_types,amenity_status,amenity_delay_type";
  const url = SUPABASE_URL + "/rest/v1/messages?select=" + cols + "&date=gte." + cutoffDateISO(7) + "&order=created_at.asc";
  const res = await fetch(url, { headers: await getDbHeaders() });
  if (!res.ok) return [];
  return res.json();
}

export async function dbSendMessage(msg) {
  const res = await fetch(SUPABASE_URL + "/rest/v1/messages", {
    method: "POST",
    headers: await getDbHeaders({ "Prefer": "return=representation" }),
    body: JSON.stringify(msg),
  });
  if (!res.ok) { console.error("Send message error", await res.text()); return null; }
  const rows = await res.json();
  return rows[0] || null;
}

export async function dbMarkMessagesRead(ids) {
  if (!ids || !ids.length) return;
  const idList = ids.join(",");
  await fetch(SUPABASE_URL + "/rest/v1/messages?id=in.(" + idList + ")", {
    method: "PATCH",
    headers: await getDbHeaders(),
    body: JSON.stringify({ read: true, read_at: new Date().toISOString() }),
  });
}

export async function dbDeleteMessage(id) {
  await fetch(SUPABASE_URL + "/rest/v1/messages?id=eq." + id, {
    method: "DELETE",
    headers: await getDbHeaders(),
  });
}

export async function dbDeleteAllMessages() {
  await fetch(SUPABASE_URL + "/rest/v1/messages?id=gte.0", {
    method: "DELETE",
    headers: await getDbHeaders(),
  });
}

export async function dbUpdateAmenityStatus(id, status, delayType) {
  await fetch(SUPABASE_URL + "/rest/v1/messages?id=eq." + id, {
    method: "PATCH",
    headers: await getDbHeaders(),
    body: JSON.stringify({ amenity_status: status, amenity_delay_type: delayType }),
  });
}

export async function dbPurgeOldMessages() {
  await fetch(SUPABASE_URL + "/rest/v1/messages?date=lt." + cutoffDateISO(7), {
    method: "DELETE",
    headers: await getDbHeaders(),
  });
}
